import { openDialog } from '@patrianna/dialog-manager'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { getIsRedeemingSelector } from '@patrianna-payments/shared-store/redeem/store/selectors'
import { useRouter, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

import Page from 'components/Page'
import ROUTES from 'config/routes.json'
import content from 'prismic-translates/page-verifications.json'
import BackButton from 'src/components/BackButton'
import { useAppSelector } from 'store/hooks'
import { isKYCRequiredSelector } from 'store/modules/kyc/selectors'
import { getIsSoftKYCAvailableSelector } from 'store/modules/user/selectors'

import IdentityVerification from '../IdentityVerification'
import { PaymentMethodVerification } from '../PaymentMethodVerification'
import CardIcon from '../PaymentMethodVerification/components/CardIcon'
import IdentityIcon from '../PaymentMethodVerification/components/IdentityIcon'
import classes from '../styles.module.scss'
import VerificationAccordion from '../VerificationAccordion'

const t = getTranslationFromJson([content])

export default function VerificationsDetails() {
  const router = useRouter()
  const isRedeeming = useAppSelector(getIsRedeemingSelector)
  const kycRequired = useAppSelector(isKYCRequiredSelector)
  const isSoftKYCAvailable = useAppSelector(getIsSoftKYCAvailableSelector)
  const searchParams = useSearchParams()

  const isCardVerificationAccordionOpened = !!searchParams.get('paymentMethodVerification')

  useEffect(() => {
    if (!isSoftKYCAvailable) {
      openDialog({ dialogName: 'SOFT_KYC_DIALOG' })
    }
  }, [isSoftKYCAvailable])

  return (
    <Page className={classes.root}>
      <div className={classes.header}>
        <BackButton className={classes.backButton} handler={() => router.push(ROUTES.MY_ACCOUNT)} />
        <h1 className='mt-typography-h4'>Verifications</h1>
      </div>

      <VerificationAccordion
        data-test='identity-verification-accordion'
        title={t('identity_verification_title')}
        icon={<IdentityIcon />}
      >
        <IdentityVerification isRedeeming={isRedeeming} kycRequired={kycRequired} />
      </VerificationAccordion>

      <VerificationAccordion
        data-test='payment-method-verification-accordion'
        title={t('card_verification_title')}
        icon={<CardIcon />}
        isPreopened={isCardVerificationAccordionOpened}
      >
        <PaymentMethodVerification />
      </VerificationAccordion>
    </Page>
  )
}
